import { render, staticRenderFns } from "./noticeDialog.vue?vue&type=template&id=4e9de295&scoped=true&"
import script from "./noticeDialog.vue?vue&type=script&lang=js&"
export * from "./noticeDialog.vue?vue&type=script&lang=js&"
import style0 from "./noticeDialog.vue?vue&type=style&index=0&id=4e9de295&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9de295",
  null
  
)

export default component.exports